import React, { useEffect, useRef, useState } from "react";
import { IKImage } from "imagekitio-react";
import "./defaultStyle.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTurnDown } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { validateCertificate, validateNewCertificate } from "../../redux/actions/certificate";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";
import GetCertifiedCard from "./NormalVariant/GetCertifiedCard";
import PersonaliseCard from "./NormalVariant/PersonaliseCard";
import SuccessStory from "./SuccessStory";
import DefaultCertifiedCard from "./DefaultComponents/DefaultCertifiedCard";
import DefaultPersonaliseCard from "./DefaultComponents/DefaultPersonaliseCard";
import Faq from "./Faq";


const CertificateVerificationDefaultMobileBody = ({targetRef , handlerCertified , handlerPersonalise}) => {
  const inputRef1 = useRef();
  const inputRef2 = useRef();
  const inputRef3 = useRef();
  const inputRef4 = useRef();
  const inputRef5= useRef();
  const [enterActive , setEnterActive] = useState(false);
  const [inputState, setInputState] = useState({
    input1: "",
    input2: "",
    input3: "",
    input4: "",
    input5 :"",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLastInputFocus , setIsLastInputFocus] = useState(false);
   const userDetails = useSelector(store => store?.certificateVerification?.userInfo);
   const [isError , setIsError] = useState(false);
  console.log(inputState);
 

  useEffect(()=>{

    if(inputState?.input1?.length > 0 && inputState?.input2?.length > 0 && inputState?.input3?.length > 0 && inputState?.input4?.length > 0 && inputState?.input5?.length > 0){
      setEnterActive(true)
    }
    else{
      setEnterActive(false);
    }
    setIsError(false);

  },[inputState])
  return (
    <div
      className="flex w-full flex-col  items-center justify-center pt-6 pb-10 leading-tight"
    >
      <div className="w-full">
        <div className="text-center">
          <div className="text-[24px] font-semibold text-white md:text-[44px]">
            Certification Verification Page
          </div>
        </div>
        <div className="w-full mt-4 flex flex-col items-center justify-center md:flex-row md:items-start md:justify-between">
          <div className="w-full leading-tight">
            <div className="w-full">
              <img
              alt="certificate images"
                src={
                  "https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Group%209931.png?updatedAt=1750927020563"
                }
                className="object-fit h-full w-full"
              ></img>
            </div>
            <form className="w-full" onSubmit={(e) => {e.preventDefault(); 
            Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_DEFAULT_VERIFY_CERTIFICATE_CLICKED);
            // Mixpanel.track(Constants.Mixpanel.SUBMIT_BUTTON_CLICKED , {distinct_id : email});
            if(inputState.input2 === "B"){
              dispatch(validateNewCertificate(inputState.input1 + "-" +inputState.input2 +  "-" + inputState.input3 + "-"+ inputState.input4 + "-" + inputState.input5 ,(link)=>{
                if(link.result === 'failed'){
                    toast.error(link.message);
                    setIsError(true)
                }
                else{
                localStorage?.setItem('userData' ,JSON.stringify(link?.data))
                navigate(`/verify/certificate/success`)
                }
          },(err)=>{setIsError(true)} ))
            }
            else{
            dispatch(validateCertificate("","unique_certificate_id",inputState.input1 + "-" +inputState.input2 +  "-" + inputState.input3 + "-"+ inputState.input4 + "-" + inputState.input5 ,(link)=>{
                if(link.result === 'failed'){
                    toast.error(link.message);
                    setIsError(true)
                }
                else{
                  localStorage?.setItem('userData' ,  JSON.stringify(link?.data))
                  navigate(`/verify/certificate/success`)
                }
            },(err)=>{setIsError(true)} ))
          
            }
          }}>
              <div className="mt-6 w-full text-center text-[14px] md:text-[16px]  text-white">
                Enter the <span className="font-semibold"> Certificate ID </span> from the certificate below:
              </div>
              <div className="mt-2 flex h-[47px] w-auto items-start py-1 justify-start">
                <input
                  className="inputDefault1 mr-1 h-[47px] rounded-lg bg-[#2D4F71] w-[35%] md:w-[20%]"
                  placeholder="PIA"
                  maxLength={3}
                  onPaste={(e)=> {
                    let text = e.clipboardData.getData('text');
                    let splitText = text.split('-');
                    console.log(splitText);
                    if(splitText.length === 5){
                      setInputState((prev) => ({
                        ...prev,
                        input1: splitText?.[0]?.toUpperCase(),
                        input2: splitText?.[1]?.toUpperCase(),
                        input3: splitText?.[2]?.toUpperCase(),
                        input4: splitText?.[3]?.toUpperCase(),
                        input5 : splitText?.[4]?.toUpperCase(),

                      }));
                      setEnterActive(true);
                    }
                    else{
                      setInputState((prev) => ({
                        ...prev,
                        input1: splitText?.[0]?.toUpperCase(),
                      }));
                    }
                }}
                  ref={inputRef1}
                  onClick={(e) => {
                    if(inputRef1?.current){
                    inputRef1?.current?.focus();
                    inputRef1?.current?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }
                  }}
                  value={inputState.input1}
                  onChange={(e) => {
                    if (e.target.value.length === 3) {
                      if(inputRef2?.current){
                      inputRef2?.current?.focus();
                      }
                    }
                    setInputState((prev) => ({
                      ...prev,
                      input1: e.target.value.toUpperCase(),
                    }));
                  }}
                />

                <span className="text-[#84A8CB] self-center">-</span>
                <input
                  className="inputDefault2 mx-1 h-[47px] w-[25%] md:w-[15%] rounded-lg bg-[#2D4F71]"
                  placeholder="M"
                  maxLength={1}
                  ref={inputRef2}
                  onClick={(e) => {
                    if(inputRef2?.current){
                    inputRef2?.current?.focus();
                    inputRef2?.current?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }
                  }}
                  value={inputState.input2}
                  onChange={(e) => {
                    if (e.target.value.length === 1) {
                      if(inputRef3?.current){
                      inputRef3?.current?.focus();
                      }
                    }
                    setInputState((prev) => ({
                      ...prev,
                      input2: e.target.value.toUpperCase(),
                    }));
                  }}
                />
                <span className="text-[#84A8CB] self-center">-</span>
                <input
                  className="inputDefault3 mx-1 h-[47px] w-[25%]  md:w-[15%]  rounded-lg bg-[#2D4F71]"
                  placeholder="2"
                  ref={inputRef3}
                  maxLength={1}
                  value={inputState.input3}
                  onClick={(e) => {
                    if(inputRef3?.current){
                    inputRef3?.current?.focus();
                    inputRef3?.current?.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    });
                  }
                  }}
                  onChange={(e) => {
                    if (e.target.value.length === 1) {
                      if(inputRef4?.current){
                      inputRef4?.current?.focus();
                      }
                    }
                    setInputState((prev) => ({
                      ...prev,
                      input3: e.target.value.toUpperCase(),
                    }));
                  }}
                />
                <span className="text-[#84A8CB] self-center">-</span>
                <div className="flex flex-col  ">
                  <input
                    className={`inputDefault3 ml-1 h-[47px] w-full rounded-lg bg-[#2D4F71]`}
                    placeholder="4466"
                    ref={inputRef4}
                    value={inputState.input4}
                    onFocus={(e)=> setIsLastInputFocus(true)}
                    onBlur={(e)=>setIsLastInputFocus(false) }
                    onClick={(e) => {
                      if(inputRef4?.current){
                      inputRef4?.current?.focus();
                      inputRef4?.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                      }
                    }}
                    onChange={(e) => {
                        if (e.target.value.length >= 1) {
                      if(inputRef4?.current){
                      inputRef4?.current?.focus();
                      }
                    }
                      setInputState((prev) => ({
                        ...prev,
                        input4: e.target.value.toUpperCase(),
                      }));
                    }}

                  />

                </div>
                  <span className="text-[#84A8CB] self-center ml-2">-</span>
                <div className="flex flex-col">
                  <input
                    className={`inputDefault3 ml-1 h-[47px] w-full rounded-lg bg-[#2D4F71]`}
                    placeholder="699442"
                    ref={inputRef5}
                    value={inputState.input5}
                    onFocus={(e)=> setIsLastInputFocus(true)}
                    onBlur={(e)=>setIsLastInputFocus(false) }
                    onClick={(e) => {
                      if(inputRef5?.current){
                      inputRef5?.current?.focus();
                      inputRef5?.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                      }
                    }}
                    onChange={(e) => {
                       if (e.target.value.length >= 1) {
                      inputRef5?.current?.focus();
                    }
                      setInputState((prev) => ({
                        ...prev,
                        input5: e.target.value.toUpperCase(),
                      }));
                    }}
                 

                  />
                 
                </div>
              </div>
              {isError && <div className="mt-2 text-[12px] md:text-[14px] w-full text-left text-[#E06064]">Invalid Certificate ID. Please try again.</div>}
              <button className={`mt-6 h-[51px] md:h-[52px] md:text-[18px]  w-full ${!enterActive && 'opacity-50'} rounded-lg bg-[#7FC241] text-[16px] font-semibold`} ref={targetRef}>
                Verify Certificate
              </button>
              {/* <div className={`mt-3 flex  items-center ${!enterActive && 'opacity-50'} tracking-wide text-white`}>
                <p className="mr-3">Press Enter</p>
                <FontAwesomeIcon
                  icon={faArrowTurnDown}
                  className="rotate-90 text-xl text-white"
                />
              </div> */}
            </form>
           
           
          </div>
        </div> 

        
         <div
        className="mt-8 -ml-4 flex w-[calc(100%+30px)] flex-col items-center justify-start bg-[#4285F4]/80  py-6 px-4"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(13, 36, 54, 1) 0%, rgba(13, 36, 54, 0.5) 100%)`,
        }}
      >
        <div className="text-center text-[24px] md:text-[28px] font-medium leading-[130%] text-white">
          <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]">
            {" "}
            3x Your Career Growth{" "}
          </span>{" "}
          With LearnTube
        </div>
        <div className="mt-4 w-full">
          <DefaultCertifiedCard  handlerCertified={handlerCertified}/>
        </div>
        <div className="mt-4 w-full">
          <DefaultPersonaliseCard handlerPersonalise={handlerPersonalise}/>
        </div>
      </div>

      <div className="mt-8">
                <SuccessStory />
              </div>
              <div className="mt-8">
        <div className="mb-4 text-center text-[24px] md:text-[28px] font-medium text-white">
          Frequently{" "}
          <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]"> Asked </span>{" "}
          Questions
        </div>
       <Faq/>
      </div>
      </div>
       
     
    </div>
  );
};

export default CertificateVerificationDefaultMobileBody;
